import request from '@/utils/axios'

export function getMessageList (params) {
  return request({
    url: '/api/push',
    method: 'get',
    params: params
  })
}